const STEP_CONFIG = {
    ['depositexpired']: {
        stepSubtitle: 'contractsView-contractsView_depositExpiredStep1Subtitle',
        stepAdvantagesTitle: 'contractsView-contractsView_depositExpiredStep1AdvantagesTitle',
        stepAdvantagesMessage1: 'contractsView-contractsView_depositExpiredStep1AdvantagesMessage1', 
        stepAdvantagesMessage2: 'contractsView-contractsView_depositExpiredStep1AdvantagesMessage2',
        stepAdvantagesMessage3: 'contractsView-contractsView_depositExpiredStep1AdvantagesMessage3',
    },
    ['depositrenewal']: {
        stepSubtitle: 'contractsView-contractsView_depositRenewalStep1Subtitle',
        stepAdvantagesTitle: 'contractsView-contractsView_depositRenewalStep1AdvantagesTitle',
        stepAdvantagesMessage1: 'contractsView-contractsView_depositRenewalStep1AdvantagesMessage1', 
        stepAdvantagesMessage2: 'contractsView-contractsView_depositRenewalStep1AdvantagesMessage2',
        stepAdvantagesMessage3: 'contractsView-contractsView_depositRenewalStep1AdvantagesMessage3',
    },
    ['deposittransfer']: {
        stepSubtitle: 'contractsView-contractsView_depositTransferStep1Subtitle',
        stepAdvantagesTitle: 'contractsView-contractsView_depositTransferStep1AdvantagesTitle',
        stepAdvantagesMessage1: 'contractsView-contractsView_depositTransferStep1AdvantagesMessage1', 
        stepAdvantagesMessage2: 'contractsView-contractsView_depositTransferStep1AdvantagesMessage2',
        stepAdvantagesMessage3: 'contractsView-contractsView_depositTransferStep1AdvantagesMessage3',
    }
}

module.exports = {
    STEP_CONFIG,
}
